import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { changePhoneNumber, getUser, koalaAnalyticsActions } from 'actions';
import PhoneFormComponent from 'components/PhoneForm/AddPhoneFormComponent';
import { forms } from 'constants';
import appSelectors from 'selectors/app-selectors';
import { resetAppErrors } from 'actions/setters/updateAppErrors';
import { trimWhiteSpace } from 'utils/validation';

const fetchData = dispatch => dispatch(getUser());

const validate = values => {
  const errors = {};
  const validUkPhoneRegex = /^(07\d{8,12}|447\d{7,11})$/;
  if (!trimWhiteSpace(values.PhoneNumber)) {
    errors.PhoneNumber = 'Please enter your mobile number';
  } else if (!validUkPhoneRegex.test(values.PhoneNumber)) {
    errors.PhoneNumber =
      'Please enter a valid UK mobile number starting with 07 or 447';
  }
  return errors;
};

const AddPhoneFormContainer = reduxForm({
  form: forms.Phone,
  validate,
})(PhoneFormComponent);

const mapStateToProps = state => ({
  initialValues: state.app.user.data,
  verifyPhone: state.app.verifyPhone,
  status: {
    isFetching: appSelectors.isPersonalDetailsFetching(state),
    ...state.app.appErrors,
  },
});

export const mapDispatchToProps = dispatch => ({
  submitHandler: (values, push) =>
    dispatch(changePhoneNumber({ values, push })),
  fetchData: () => {
    fetchData(dispatch);
  },
  trackPageView: (subtype, pageSection) => {
    koalaAnalyticsActions.trackPageView(subtype, pageSection)(dispatch);
  },
  trackLinkClick: (subtype, pageSection, eventValue) => {
    koalaAnalyticsActions.trackLinkClick(
      subtype,
      pageSection,
      eventValue,
    )(dispatch);
  },
  resetAppErrors: () => {
    dispatch(resetAppErrors());
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps);

const AddPhoneFormContainerConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(AddPhoneFormContainer);

AddPhoneFormContainerConnected.fetchData = fetchData;

export default AddPhoneFormContainerConnected;
